import React from 'react';
import {
  ErrorMessage,
  FormController,
} from '../../../assets/global/globalStyles';
import { SelectContainer, Select, Option } from './styles';
import useFormType from '../../../hooks/useFormType';

/**
 * @param props
 * @param {String} props.name
 * @param {String} props.label
 * @param {Array<Object>} props.options
 */
export default function SelectC({
  name,
  label,
  options,
  grid,
  gridRow,
  ...rest
}) {
  const { fieldName, defaultValue, error, ref, location } = useFormType(name);

  return (
    <FormController grid={grid} gridRow={gridRow}>
      <SelectContainer>
        {label}
        <Select
          location={location.pathname}
          defaultValue={defaultValue}
          autoComplete="off"
          id={fieldName}
          error={error}
          ref={ref}
          {...rest}
        >
          {options.map((opt) => (
            <Option
              key={opt.value}
              selected={defaultValue === opt.value}
              value={opt.value}
            >
              {opt.label}
            </Option>
          ))}
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </Select>
      </SelectContainer>
    </FormController>
  );
}
